import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { RootState } from 'appHooks'
import { merge } from 'shared/utils/mergeObjects'

const initialState = {
  focusedRepaymentYear: undefined,
}

export const setFocusedRepaymentYearThunk = createAsyncThunk(
  'loan/setFocusedRepaymentYear',
  (focusedRepaymentYear: Partial<number | undefined>, thunkApi) => {
    thunkApi.dispatch(
      loanSlice.actions.setFocusedRepaymentYear(focusedRepaymentYear)
    )
  }
)

const loanSlice = createSlice({
  name: 'loans',
  initialState,
  reducers: {
    setFocusedRepaymentYear: (
      state,
      action: PayloadAction<Partial<number | undefined>>
    ) => {
      state.focusedRepaymentYear = merge(action.payload)
    },
  },
})

export const getFocusedRepaymentYear = (state: RootState) =>
  state.loans.focusedRepaymentYear

export default loanSlice
